import {
  ContactInformationActions,
  FlightPassengerActions,
  ReviewActions,
  SeatActions,
  AirPFExerciseActions,
  CfarActions,
  AirDisruptionActionsV1,
  CartActions,
  FlightActions,
  PassportActions,
  VipSupportActions,
  AirChfarActions,
  AirChfarExerciseDiscountActions,
  AirPriceDropActions,
} from "@hopper-b2b/checkout";

import { CartFulfillActions } from "../states/CartFulfill";
import { commonActions } from "./common";
import { paymentActions } from "./payment";

export const Actions = {
  ...FlightActions,
  ...CartActions,
  ...AirDisruptionActionsV1,
  ...CartFulfillActions,
  ...CfarActions,
  ...ContactInformationActions,
  ...FlightPassengerActions,
  ...PassportActions,
  ...AirPFExerciseActions,
  ...ReviewActions,
  ...SeatActions,
  ...VipSupportActions,
  ...commonActions,
  ...paymentActions,
  ...AirChfarActions,
  ...AirChfarExerciseDiscountActions,
  ...AirPriceDropActions,
};

type IActionTypes = {
  [K in keyof typeof Actions]: K;
};

export const ActionTypes: IActionTypes = Object.keys(Actions).reduce(
  (prev, cur) => ({ ...prev, [cur]: cur }),
  {} as IActionTypes
);
